import type { PathConfig } from '@react-navigation/native';
import { listingLinking, newAddressLinking, userProfileLinking } from './billboard/navigator';
import { linking as chatLinking } from './chat/navigator';
import { linking as introLinking } from './intro/navigator';
import { linking as mainLinking } from './main-tab';
import { linking as managementLinking } from './management/navigator';
import { linking as onboardingLinking } from './onboarding/navigator';
import { linking as passwordRecoveryLinking } from './password-recovery/navigator';
import { linking as quickNewLinking } from './quick-new/navigator';
import type { Parameters } from './root-stack';

export const linking: PathConfig<Parameters> = {
  screens: {
    'password-recovery': passwordRecoveryLinking,
    chat: chatLinking,
    invite: '/invite',
    new: '/new',
    bulkNew: '/new/bulk',
    'offer-hub': '/offer-hub',
    'edit-listing': '/listing/:id/edit',
    paywall: '/paywall',
    serviceCategories: '/serviceCategories',
    'my-address': '/my-address',
    categories: '/categories',
    tags: '/tags',
    main: mainLinking,
    onboardingIntro: '/onboardingIntro',
    onboarding: onboardingLinking,
    splash: '/splash',
    payment: '/payment',
    'payment-success': '/payment/success',
    quickNew: quickNewLinking,
    loan: managementLinking,
    freeSub: '/freeSub',
    intro: introLinking,
    trialPromo: '/trialPromo',
    'offer-availability': '/listing/:listingId/availability',
    'loan-dates-picker': '/:url/dates',
    'loan-fee': '/listing/:listingId/loanFee',
    refrainOfferAvailabilityPopup: '/refrainOfferAvailabilityPopup',
    listingModal: listingLinking,
    userProfileModal: userProfileLinking,
    newAddressModal: newAddressLinking,
    'notification-explainer': '/notification-explainer',
    'notifications-setting': '/notification-settings',
    'notification-super-changed': '/notification-super-changed',
    chooseUserType: '/choose-user-type',
    publicUserWelcome: '/public-user-welcome',
    presentPartageClub: '/presentPartageClub',
    presentCommunity: '/presentCommunity',
    'new-post': '/new-post',
    'new-rating': '/new-rating',
    'rating-thanks': '/rating-thanks',
    'update-rating': '/update-rating',
    'edit-post': '/edit-post',
    'post-comments': '/post-comments/:postId',
    streak: '/streak',
    'streak-members': '/streak/members/:period',
    help: '/help',
  },
};
